import React from 'react';

import { observer, inject } from "mobx-react";
import { Modal as ModalComponent, LeftMenu as LeftMenuComponent, Spinner as SpinnerComponent, AuthMenu as MenuComponent, Messages as MessagesComponent } from '@sogei/react-web-components-catalog'
import { PATH_PORTALE} from '../config/portale-config';
import { configureHeader, configureFooter, AgenziaAuthHeader, AgenziaAuthFooter } from '@sogei/agenzia-entrate-common'
//import { configureHeader, configureFooter, AgenziaAuthHeader, AgenziaAuthFooter } from './agenzia-header.jsx'


const title = "Area Riservata"
const subtitlePegni = "Registro dei pegni non possessori"
const subtitleUnimodweb = "Modello Unico Informatico (MUI)"
const subtitlePegniCert = "Registro dei pegni non possessori"
const subtitleCancIpoteca = "Comunicazioni di cancellazione semplificata di ipoteca"

const organization = {
  name: 'Agenzia delle Entrate',
  url: 'https://www.agenziaentrate.gov.it'
}

const buttonList = [
  {
    url: "https://www.agenziaentrate.gov.it",
    icon: "fas fa-info",
    title: "Info e Assistenza"
  },
  {
    url: PATH_PORTALE + '/home',
    icon: "fas fa-sign-out-alt fa-rotate-270",
    title: "Area riservata"
  }
]

const ModalBody = ({ selectedNews }) => <>
  {selectedNews.dataScadenza}

  <div dangerouslySetInnerHTML={{ __html: selectedNews.testo }}></div>

  {selectedNews.error ?
    <div className="alert alert-danger d-flex" role="alert">
      <p className="alert-content"> {selectedNews.error}</p>
    </div>
    : null
  }
</>
const Modal = inject(({ rootStore }) => {
  return {
    data: {
      title: rootStore.homeStore.selectedNews.titolo,
      body: <ModalBody selectedNews={rootStore.homeStore.selectedNews}></ModalBody>
    }
  }
})
(ModalComponent)



const AuthHeader = inject(({ rootStore }) => {
  let subtitle = '';
  if(rootStore.menuStore.config.fromPegni) {
    subtitle = subtitlePegni
  }
  if(rootStore.menuStore.config.fromUnimodweb) {
    subtitle = subtitleUnimodweb
  }
  if(rootStore.menuStore.config.fromPegniCert) {
    subtitle = subtitlePegniCert
  }
  if(rootStore.menuStore.config.fromCancellazioni) {
    subtitle = subtitleCancIpoteca
  }
  return configureHeader(rootStore, title, subtitle, organization, buttonList)
})(AgenziaAuthHeader)




const AuthFooter = inject(() => configureFooter(title))(AgenziaAuthFooter)

const AuthMenu = inject(({ rootStore }) => ({
  idMenu: '',
  menuItems: [{
    items: rootStore.menuStore.menuItems.map(menu => {
      if(menu.subItems) {
        return {...menu, subItems: menu.subItems.map(subItem => subItem)};
      }
      return menu;
    })
  }],
  location: rootStore.routingStore.location,
  fetchMenuItems: async() => await rootStore.menuStore.fetchMenuItems()
}))(MenuComponent)


const LeftMenu = inject(({ rootStore }) => ({
  context: process.env.CONTEXT_PATH,
 
   leftMenuItems:rootStore.leftMenuStore.menuItems.map(item=>
     {   
       if(item.subItems!==undefined){     
        let subItems=[];
         item.subItems.forEach( (item, index) =>{
             subItems[index] = {label: item.label, path:item.path}
            return subItems;
          })
         return(
            {exact: true,label: [item.label],path:[item.path], subItems:subItems}            
         )
       }else{ 
     return(
       { exact: true,label: [item.label], path: item.path}
     )}
   }),
   label: rootStore.leftMenuStore.label,
   menuOptions:['items-indent'],
   fetchLeftMenuItems: () => rootStore.leftMenuStore.fetchLeftMenu()
  }))(LeftMenuComponent)












const Messages = inject(({ rootStore }) => ({
  successMessages: rootStore.uiStore.successMessages,
  infoMessages: rootStore.uiStore.infoMessages,
  warningMessages: rootStore.uiStore.warningMessages,
  dangerMessages: rootStore.uiStore.dangerMessages,
  messagesCount: rootStore.uiStore.messagesCount
}))(MessagesComponent)

const Spinner = inject(({ rootStore }) => ({ isLoading: rootStore.uiStore.isLoading }))(observer(SpinnerComponent))

export {Modal, Spinner, Messages, AuthHeader, AuthFooter, AuthMenu, LeftMenu }
//export {Modal, Spinner, Messages, AuthHeader, AuthFooter, AuthMenu }